import React, {useState} from 'react';
import {Navbar, Nav, Button, Container} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Modal} from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import { deepPurple } from '@material-ui/core/colors';
import BrandImage from './logo.png';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  orange: {
    color: theme.palette.getContrastText(deepPurple[500]),
    backgroundColor: deepPurple[500],
  },
}));

const NavBar = ({homepage}) => {
  
  const history = useHistory();
  const dispatch = useDispatch();
  const classes = useStyles();

  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));
  const [show, setShow] = useState(false);
  
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  
  const logout = () =>{
    dispatch({type: 'LOGOUT'});
    history.push('/');
  };
  
  const ownerInformation = JSON.parse(localStorage.getItem('profile'));
  
  return (
      <Navbar sticky = "top" collapseOnSelect expand="lg" bg="dark" variant="dark">
        <Container>
          <Navbar.Brand href={ownerInformation ? "/homepage" : "/"}> <img
            alt=""
            src={BrandImage}  
            width="30"
            height="30"
            className="d-inline-block align-top"
          /> {' '} Bookstore
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            {!homepage && 
              <>
                <Nav.Link href="mybooks">My Books</Nav.Link>
                <Nav.Link href="myrequests">My Requests</Nav.Link>
                <Nav.Link href="web">Search Web</Nav.Link>
                <Nav.Link href="myinformation">My Information</Nav.Link>
              </>
            }
          </Nav>
          <Modal centered show={show} onHide={handleClose}>
            <Modal.Header>
              <Modal.Title>Logging Out</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to log out? </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-dark" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="outline-danger" onClick={logout}>
                Log Out
              </Button>
            </Modal.Footer>
          </Modal>
          {homepage ? (
            <>
              <Nav>
                <Nav.Link disabled>About</Nav.Link>
                <Nav.Link disabled>Contact Us</Nav.Link>
              </Nav>
            </>
            ):(
            <>
              <div className={classes.root}>
                <Avatar className = {classes.orange} alt={user?.result?.name} src={user?.result?.image} />
              </div> &nbsp; &nbsp; &nbsp;
              <Button onClick = {handleShow} variant="outline-light"> Log Out </Button>
            </>)
          }
          </Navbar.Collapse>
        </Container>
      </Navbar>
  )
}

export default NavBar
